import React from 'react';

const emojiFont = '"Noto Color Emoji", sans-serif';

export function wrapEmoji(emoji, ...triggers) {
  const fn = (props) => <span children={emoji}
    style={{
      fontFamily: emojiFont,
      fontSize: typeof props.size === 'number'
        ? `${props.size}px`
        : undefined
    }}
  />;
  fn.emoji = emoji;
  fn.triggers = triggers;
  return fn;
}


// --- Emojis ---
// Core
const Flame = wrapEmoji('🔥', 'fire', 'hot', 'burn', 'lit');
const Snowflake = wrapEmoji('❄️', 'ice', 'cold', 'freeze', 'snow');
const Snowflake2 = wrapEmoji('❅');
const Snowflake3 = wrapEmoji('❆');
const Thermometer = wrapEmoji('🌡️', 'temperature');
const CautionMark = wrapEmoji('⚠️',
    'warning', 'error', 'caution', 'danger', 'hazard');
const Alarm = wrapEmoji('🔔', 'alarm', 'alert', 'notification');
const Bell = wrapEmoji('🛎️', 'bell');
const Memo = wrapEmoji('📝', 'memo', 'note', 'write', 'document');
const Crown = wrapEmoji('👑', 'crown', 'king');
const Key = wrapEmoji('🔑', 'key', 'password', 'credential');
const Admin = wrapEmoji('👩‍💻', 'admin', 'administrator');

// --- Tech / Computer ---
const Laptop = wrapEmoji('💻', 'laptop');
const DesktopComputer = wrapEmoji('🖥️', 'desktop', 'computer');
const Keyboard = wrapEmoji('⌨️', 'keyboard');
const Mouse = wrapEmoji('🖱️', 'mouse');
const Trackball = wrapEmoji('🖲️', 'trackball');
const MobilePhone = wrapEmoji('📱', 'mobile', 'phone');
const PhoneWithArrow = wrapEmoji('📲', 'call');
const Battery = wrapEmoji('🔋', 'battery', 'charge');
const ElectricPlug = wrapEmoji('🔌', 'AC', 'plug');
const FloppyDisk = wrapEmoji('💾', 'disk', 'floppy');
const OpticalDisk = wrapEmoji('💿', 'cd');
const DVD = wrapEmoji('📀', 'dvd', 'bluray');
const Printer = wrapEmoji('🖨️', 'printer');

// --- RF / Communications ---
const SatelliteAntenna = wrapEmoji('📡', 'antenna');
const AntennaBars = wrapEmoji('📶', 'signal');
const Radio = wrapEmoji('📻', 'radio');
const Satellite = wrapEmoji('🛰️', 'satellite');
const Pager = wrapEmoji('📟', 'pager');

// --- Cleaning ---
const Broom = wrapEmoji('🧹', 'sweep', 'broom', 'clean', 'cleaning');
const Bucket = wrapEmoji('🪣', 'mop', 'bucket', 'water', 'wash');
const Soap = wrapEmoji('🧼', 'soap');
const Sponge = wrapEmoji('🧽', 'sponge');
const RollOfPaper = wrapEmoji('🧻', 'tissue',
    'toilet', 'paper', 'napkin', 'paper', 'towel');

// --- Beverages ---
const HotBeverage = wrapEmoji('☕', 'coffee');
const Teacup = wrapEmoji('🍵', 'tea');
const BubbleTea = wrapEmoji('🧋');
const BeverageBox = wrapEmoji('🧃', 'drinkbox');
const Milk = wrapEmoji('🥛', 'milk');
const WineGlass = wrapEmoji('🍷', 'wine');
const TropicalDrink = wrapEmoji('🍹', 'drink', 'tropical', 'cocktail');

// --- Food ---
// [Full food emoji list retained from your original code]
const Pizza = wrapEmoji('🍕', 'pizza');
const Chicken = wrapEmoji('🍗', 'chicken');
const GreenApple = wrapEmoji('🍏', 'apple');
const RedApple = wrapEmoji('🍎');
const Pear = wrapEmoji('🍐', 'pear');
const Tangerine = wrapEmoji('🍊', 'tangerine');
const Lemon = wrapEmoji('🍋', 'lemon');
const Banana = wrapEmoji('🍌', 'banana');
const Watermelon = wrapEmoji('🍉', 'watermelon');
const Grapes = wrapEmoji('🍇', 'grape');
const Strawberry = wrapEmoji('🍓', 'strawberry');
const Blueberries = wrapEmoji('🫐', 'blueberry');
const Melon = wrapEmoji('🍈', 'melon');
const Cherries = wrapEmoji('🍒', 'cherry', 'cherries');
const Peach = wrapEmoji('🍑', 'peach');
const Mango = wrapEmoji('🥭', 'mango');
const Pineapple = wrapEmoji('🍍', 'pineapple');
const Coconut = wrapEmoji('🥥', 'coconut');
const KiwiFruit = wrapEmoji('🥝', 'kiwi');
const Tomato = wrapEmoji('🍅', 'tomato');
const Eggplant = wrapEmoji('🍆', 'eggplant');
const Avocado = wrapEmoji('🥑', 'avocado');
const Broccoli = wrapEmoji('🥦', 'broccoli');
const LeafyGreen = wrapEmoji('🥬', 'green');
const Cucumber = wrapEmoji('🥒', 'cucumber');
const HotPepper = wrapEmoji('🌶️', 'pepper');
const BellPepper = wrapEmoji('🫑', 'bell pepper');
const Corn = wrapEmoji('🌽', 'corn');
const Carrot = wrapEmoji('🥕', 'carrot');
const Olive = wrapEmoji('🫒', 'olive');
const Potato = wrapEmoji('🥔', 'potato');
const RoastedSweetPotato = wrapEmoji('🍠', 'sweet potato');
const Croissant = wrapEmoji('🥐', 'croissant', 'breakfast', 'pastry');
const Bagel = wrapEmoji('🥯', 'bagel', 'dough');
const Bread = wrapEmoji('🍞', 'bread');
const BaguetteBread = wrapEmoji('🥖', 'baguette');
const Pretzel = wrapEmoji('🥨', 'pretzel');
const Cheese = wrapEmoji('🧀', 'cheese', 'dairy');
const MeatOnBone = wrapEmoji('🍖', 'meat');
const CutOfMeat = wrapEmoji('🥩', 'cut');
const Bacon = wrapEmoji('🥓', 'bacon');
const Hamburger = wrapEmoji('🍔', 'burger');
const FrenchFries = wrapEmoji('🍟', 'fries');
const HotDog = wrapEmoji('🌭', 'dog');
const Sandwich = wrapEmoji('🥪', 'sandwich');
const Taco = wrapEmoji('🌮', 'taco', 'mexican');
const Burrito = wrapEmoji('🌯');
const StuffedFlatbread = wrapEmoji('🥙', 'flatbread');
const Falafel = wrapEmoji('🧆', 'falafel');
const Egg = wrapEmoji('🥚', 'egg');
const Cooking = wrapEmoji('🍳', 'cooking');
const ShallowPanOfFood = wrapEmoji('🥘', 'pan');
const PotOfFood = wrapEmoji('🍲', 'pot');
const BowlWithSpoon = wrapEmoji('🥣', 'bowl');
const GreenSalad = wrapEmoji('🥗', 'salad');
const Popcorn = wrapEmoji('🍿', 'popcorn');
const Butter = wrapEmoji('🧈', 'butter');
const Waffle = wrapEmoji('🧇', 'waffle');
const Pancakes = wrapEmoji('🥞', 'pancake');
const BentoBox = wrapEmoji('🍱', 'bento');
const RiceCracker = wrapEmoji('🍘', 'ricecake');
const RiceBall = wrapEmoji('🍙', 'rice ball');
const CookedRice = wrapEmoji('🍚', 'cooked rice');
const CurryRice = wrapEmoji('🍛', 'curry');
const SteamingBowl = wrapEmoji('🍜', 'steaming');
const Spaghetti = wrapEmoji('🍝', 'spaghetti');
const Oden = wrapEmoji('🍢', 'oden');
const Sushi = wrapEmoji('🍣', 'sushi');
const FriedShrimp = wrapEmoji('🍤', 'shrimp');
const FishCakeWithSwirl = wrapEmoji('🍥', 'fishcake');
const MoonCake = wrapEmoji('🥮', 'moon cake');
const Dango = wrapEmoji('🍡', 'dango');
const Dumpling = wrapEmoji('🥟', 'dumpling');
const FortuneCookie = wrapEmoji('🥠', 'fortune cookie');
const TakeoutBox = wrapEmoji('🥡', 'takeout');
const Crab = wrapEmoji('🦀', 'crab');
const Lobster = wrapEmoji('🦞', 'lobster');
const Shrimp = wrapEmoji('🦐', 'shrimp');
const Squid = wrapEmoji('🦑', 'squid');
const SoftIceCream = wrapEmoji('🍦',
    'ice', 'iced', 'cream', 'cone', 'soft', 'serve');
const ShavedIce = wrapEmoji('🍧', 'shaved');
const IceCream = wrapEmoji('🍨', 'ice', 'iced', 'cream');
const Donut = wrapEmoji('🍩', 'donut');
const Cookie = wrapEmoji('🍪', 'cookie');
const BirthdayCake = wrapEmoji('🎂', 'birthday');
const Shortcake = wrapEmoji('🍰', 'shortcake');
const Cupcake = wrapEmoji('🧁', 'cupcake');
const Pie = wrapEmoji('🥧', 'pie');
const ChocolateBar = wrapEmoji('🍫', 'chocolate');
const Candy = wrapEmoji('🍬', 'candy');
const Lollipop = wrapEmoji('🍭', 'lollipop', 'candy');
const Custard = wrapEmoji('🍮', 'custard');
const HoneyPot = wrapEmoji('🍯', 'honeypot');

// --- Export ---
export const unicodeIcons = {
  // Core
  flame: Flame,
  snowflake: Snowflake,
  snowflake2: Snowflake2,
  snowflake3: Snowflake3,
  thermometer: Thermometer,
  cautionMark: CautionMark,
  alarm: Alarm,
  bell: Bell,
  memo: Memo,
  crown: Crown,
  key: Key,
  admin: Admin,

  // Tech
  laptop: Laptop,
  desktopComputer: DesktopComputer,
  keyboard: Keyboard,
  mouse: Mouse,
  trackball: Trackball,
  mobilePhone: MobilePhone,
  phoneWithArrow: PhoneWithArrow,
  battery: Battery,
  electricPlug: ElectricPlug,
  floppyDisk: FloppyDisk,
  opticalDisk: OpticalDisk,
  dVD: DVD,
  printer: Printer,

  // RF / Communication
  satelliteAntenna: SatelliteAntenna,
  antennaBars: AntennaBars,
  radio: Radio,
  satellite: Satellite,
  pager: Pager,

  // Cleaning
  broom: Broom,
  bucket: Bucket,
  soap: Soap,
  sponge: Sponge,
  rollOfPaper: RollOfPaper,

  // Drinks
  hotBeverage: HotBeverage,
  teacup: Teacup,
  bubbleTea: BubbleTea,
  beverageBox: BeverageBox,
  milk: Milk,
  wineGlass: WineGlass,
  tropicalDrink: TropicalDrink,

  // Food
  pizza: Pizza,
  chicken: Chicken,
  greenApple: GreenApple,
  redApple: RedApple,
  pear: Pear,
  tangerine: Tangerine,
  lemon: Lemon,
  banana: Banana,
  watermelon: Watermelon,
  grapes: Grapes,
  strawberry: Strawberry,
  blueberries: Blueberries,
  melon: Melon,
  cherries: Cherries,
  peach: Peach,
  mango: Mango,
  pineapple: Pineapple,
  coconut: Coconut,
  kiwiFruit: KiwiFruit,
  tomato: Tomato,
  eggplant: Eggplant,
  avocado: Avocado,
  broccoli: Broccoli,
  leafyGreen: LeafyGreen,
  cucumber: Cucumber,
  hotPepper: HotPepper,
  bellPepper: BellPepper,
  corn: Corn,
  carrot: Carrot,
  olive: Olive,
  potato: Potato,
  roastedSweetPotato: RoastedSweetPotato,
  croissant: Croissant,
  bagel: Bagel,
  bread: Bread,
  baguetteBread: BaguetteBread,
  pretzel: Pretzel,
  cheese: Cheese,
  meatOnBone: MeatOnBone,
  cutOfMeat: CutOfMeat,
  bacon: Bacon,
  hamburger: Hamburger,
  frenchFries: FrenchFries,
  hotDog: HotDog,
  sandwich: Sandwich,
  taco: Taco,
  burrito: Burrito,
  stuffedFlatbread: StuffedFlatbread,
  falafel: Falafel,
  egg: Egg,
  cooking: Cooking,
  shallowPanOfFood: ShallowPanOfFood,
  potOfFood: PotOfFood,
  bowlWithSpoon: BowlWithSpoon,
  greenSalad: GreenSalad,
  popcorn: Popcorn,
  butter: Butter,
  waffle: Waffle,
  pancakes: Pancakes,
  bentoBox: BentoBox,
  riceCracker: RiceCracker,
  riceBall: RiceBall,
  cookedRice: CookedRice,
  curryRice: CurryRice,
  steamingBowl: SteamingBowl,
  spaghetti: Spaghetti,
  oden: Oden,
  sushi: Sushi,
  friedShrimp: FriedShrimp,
  fishCakeWithSwirl: FishCakeWithSwirl,
  moonCake: MoonCake,
  dango: Dango,
  dumpling: Dumpling,
  fortuneCookie: FortuneCookie,
  takeoutBox: TakeoutBox,
  crab: Crab,
  lobster: Lobster,
  shrimp: Shrimp,
  squid: Squid,
  softIceCream: SoftIceCream,
  shavedIce: ShavedIce,
  iceCream: IceCream,
  donut: Donut,
  cookie: Cookie,
  birthdayCake: BirthdayCake,
  shortcake: Shortcake,
  cupcake: Cupcake,
  pie: Pie,
  chocolateBar: ChocolateBar,
  candy: Candy,
  lollipop: Lollipop,
  custard: Custard,
  honeyPot: HoneyPot,
};

export function findMatchingEmoji(templateName, emojiList) {
  const lower = templateName.toLowerCase();
  return emojiList.find(emojiFn =>
    emojiFn.triggers?.some(trigger => lower.includes(trigger))
  );
}

function normalizeText(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s]/g, '') // remove punctuation
    .trim();
}

export function findBestEmoji(templateName, emojiList) {
  const words = normalizeText(templateName).split(/\s+/);
  let best = null;
  let maxScore = 0;

  for (const emojiFn of emojiList) {
    let score = 0;
    for (const word of words) {
      if (emojiFn.triggers?.includes(word)) score++;
    }
    if (score > maxScore) {
      maxScore = score;
      best = emojiFn;
    }
  }

  return best;
}
